<template>
  <div class="modal-card" style="max-width: 500px;">
    <CloseIcon :size="24" class="close-modal-icon close-on-click" />
    <div class="modal-card-header">
      <h1 class="title">Create Practice</h1>
    </div>
    <div class="modal-card-body">
      <div class="form-grid">
        <div class="form-row">
          <label for="practiceName" class="form-label">Practice Name</label>
          <TextInput v-model="practiceName" placeholder="Enter practice name" ref="practiceNameInput" />
        </div>
      </div>
    </div>
    <div class="modal-card-footer">
      <button class="button secondary form-button close-on-click" @click="handleCancel">
        Cancel
      </button>
      <button class="button primary form-button" @click="handleSubmit" :disabled="isSubmitting || !practiceName.trim()">
        {{ isSubmitting ? 'Creating...' : 'Create Practice' }}
      </button>
    </div>
    <div v-if="error" class="modal-error">
      {{ error }}
    </div>
  </div>
</template>

<script>
import TextInput from '@/components/inputs/TextInput.vue';
import CloseIcon from 'vue-material-design-icons/Close.vue';
import * as api from '@/api';

export default {
  name: "CreatePracticeModal",
  components: {
    TextInput,
    CloseIcon
  },
  emits: ['close', 'practice-created'],
  data() {
    return {
      practiceName: '',
      isSubmitting: false,
      error: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.practiceNameInput?.$el?.focus();
    });
  },
  methods: {
    handleCancel() {
      // Close modal via close-on-click class
    },
    async handleSubmit() {
      this.error = null;

      if (!this.practiceName.trim()) {
        this.error = 'Practice name is required';
        return;
      }

      this.isSubmitting = true;

      try {
        const practice = await api.createPractice({ name: this.practiceName.trim() });
        this.$emit('practice-created', practice);
      } catch (err) {
        console.error('Failed to create practice:', err);
        this.error = err.message || 'Failed to create practice';
        this.isSubmitting = false;
      }
    }
  }
}
</script>

<style scoped>
.form-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
</style>
